module.exports = __webpack_public_path__ + "img/polygon.bfcc99a4.png";